export const marinetrafficUrl = mmsi =>
  `https://www.marinetraffic.com/en/ais/details/ships/mmsi:${mmsi}/imo:0`;
